import moment from 'moment';

export function getMinuteAsOfNow(time) {
  return getMinuteDiff(new Date(), time);
}

export function getMinuteDiff(late, early) {
  let seconds = getSecondDiff(late, early);
  // return parseInt(seconds);
  return parseInt(seconds / 60);
}

export function getSecondDiff(late, early) {
  if (!early) {
    return 0;
  }

  if (typeof late === 'string') {
    late = new Date(late);
  }

  if (typeof early === 'string') {
    early = new Date(early);
  }

  let seconds = (late - early) / 1000;
  return parseInt(seconds);
}

export function getDOBFormat(DOBString) {
  return moment(DOBString).format('DD/MM/YYYY');
}

export function getLastUpdateDateAndTimeFormat(UTCString, timezoneOffset, dateOrTime) {
  if (dateOrTime == 'dateOnly') {
    return moment.utc(UTCString).utcOffset(timezoneOffset).format('DD MMMM YYYY');
  } else if (dateOrTime == 'timeOnly') {
    return moment.utc(UTCString).utcOffset(timezoneOffset).format('hh:mm A');
  } else {
    return moment.utc(UTCString).utcOffset(timezoneOffset).format('DD MMMM YYYY hh:mm A');
  }
}
